module.exports = __webpack_public_path__ + "static/mr-press-16-83e4e4fdfd6a1026b235b35581d6ef00.jpg";